export default "__VITE_ASSET__DpxypZ5R__"